import Parse from 'parse';
import { AteneaBoxStatus, BoxStatus, ParseQueryParams } from "../constants"
import { PlaceModel } from "./place"

export interface GetSpacesQueryParams extends ParseQueryParams {
    placeId?: string
    areaId?: string
    objectIds?:string[]
}


export enum LockOpenStatus {    
    'OPEN' = 1,
    'CLOSED' = 2,
    'FAILED' = 3
}
export class SpaceModel extends Parse.Object {

    static defaultFindIncludes = []

    static getAll(params: GetSpacesQueryParams): Promise<SpaceModel[]> {
        const query = new Parse.Query(this)
        const defaultParams: Partial<GetSpacesQueryParams> = { sort: { field: 'canonical', direction: 'asc' } }
        params = Object.assign({}, defaultParams, params)
        const limit:number = params.limit || 10000

        if (params.areaId) {
            debugger
            console.log('areaId: ',params.areaId)
            const areaQuery = new Parse.Query('PlaceArea').equalTo('objectId', params.areaId)
            query.matchesQuery('area', areaQuery)
        }

        if (params.placeId) {
            const placeQuery = new Parse.Query('Place').equalTo('objectId', params.placeId)
            query.matchesQuery('place', placeQuery)
        }

        if(params.objectIds){
            query.containedIn('objectId',params.objectIds)
        }

        if (params.sort) {
            if (params.sort.direction == 'asc') {
                query.ascending(params.sort.field)
            } else {
                query.descending(params.sort.field)
            }
        }
        
        query.limit(limit)

        return query.find()
    }

    static convertAteneaStatus(remoteStatus: string): AteneaBoxStatus {
        if (remoteStatus == 'available') {
            return AteneaBoxStatus.AVAILABLE
        }
        if (remoteStatus == 'rented') {
            return AteneaBoxStatus.RENTED
        }
        if (remoteStatus == 'maintenance') {
            return AteneaBoxStatus.MAINTENANCE
        }
        if (remoteStatus == 'reserved') {
            return AteneaBoxStatus.RESERVED
        }
        return AteneaBoxStatus.UNKNOWN
    }

    constructor(attr = {}) {
        super('Space', attr);
    }

    getDefaultAcl() {
        const acl = new Parse.ACL()
        acl.setPublicReadAccess(true)
        acl.setRoleWriteAccess('Admin', true)
        return acl
    }

    get place(): PlaceModel {
        return this.get('place');
    }

    set place(val: PlaceModel) {
        this.set('place', val);
    }

    get ateneaId(): string {
        return this.get('ateneaId');
    }

    set ateneaId(val: string) {
        this.set('ateneaId', val);
    }

    get ateneaStatus(): AteneaBoxStatus {
        return this.get('ateneaStatus');
    }

    set ateneaStatus(val: AteneaBoxStatus) {
        this.set('ateneaStatus', val);
    }

    get name(): string {
        return this.get('name');
    }

    set name(val: string) {
        this.set('name', val);
    }

    get status(): BoxStatus {
        return this.get('status');
    }

    set status(val: BoxStatus) {
        this.set('status', val);
    }

    get meters(): number {
        return this.get('meters');
    }

    set meters(val: number) {
        this.set('meters', val);
    }

    get price(): number {
        return this.get('price');
    }

    set price(val: number) {
        this.set('price', val);
    }

    get isAvailable(): boolean {
        return this.ateneaStatus == AteneaBoxStatus.AVAILABLE
    }

    get isRented(): boolean {
        return this.ateneaStatus == AteneaBoxStatus.RENTED
    }

    get lockOpenStatus(): LockOpenStatus {
        return this.get('lockOpenStatus');
    }

    set lockOpenStatus(val: LockOpenStatus) {
        this.set('lockOpenStatus', val);
    }

    hide() {
        return this.save({ status: BoxStatus.HIDDEN }, { useMasterKey: true })
    }

    unhide() {
        return this.save({ status: BoxStatus.NORMAL }, { useMasterKey: true })
    }

    get isHidden(): boolean {
        return this.status == BoxStatus.HIDDEN
    }

    getAteneStatusString(): string {
        if (this.ateneaStatus == AteneaBoxStatus.AVAILABLE) {
            return 'Disponible'
        }
        if (this.ateneaStatus == AteneaBoxStatus.RENTED) {
            return 'Alquilado'
        }
        if (this.ateneaStatus == AteneaBoxStatus.MAINTENANCE) {
            return 'Mantenimiento'
        }
        if (this.ateneaStatus == AteneaBoxStatus.RESERVED) {
            return 'Reservado'
        }
        return '-'
    }

    getLockOpenStatusString(): string {    
        if (this.lockOpenStatus == LockOpenStatus.OPEN) {
            return 'Abierto'
        }
        if (this.lockOpenStatus == LockOpenStatus.CLOSED) {
            return 'Cerrado'
        }
        if (this.lockOpenStatus == LockOpenStatus.FAILED) {
            return 'Error'
        }
        return '-'
    }

    get ateneaUrl(){
        return `${this.place.ateneaUrl}/web?#id=${this.ateneaId}&model=arestrasteros.trastero&view_type=form`
    }

}

Parse.Object.registerSubclass('Space', SpaceModel)
